/* eslint-disable max-len */
import { DASHBOARD_STATUS_COLOR_MAP } from '../../grid_view_1/constants';

const STATUS_COLORS = DASHBOARD_STATUS_COLOR_MAP;
const IN_TRANSIT_COLORS = STATUS_COLORS['In Transit'];
const DELIVERED_COLORS = STATUS_COLORS.Delivered;
const IN_PROCESS_COLORS = STATUS_COLORS['In Process'];
const CANCELLED_COLORS = STATUS_COLORS.Cancelled;

const laneView1Styles = () => ({
    mainDiv: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        background: '#F5F5F5',
        padding: '16px',
    },

    // ========== FILTER BAR (Reused from grid view) ==========
    filterBarContainer: {
        margin: 0,
        padding: '16px 24px',
        backgroundColor: '#FFFFFF',
        borderRadius: 12,
        border: '1px solid #F0F0F0',
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        marginBottom: 16,
    },

    topFilterRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        flexWrap: 'wrap',
    },

    bottomFilterRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 16,
        flexWrap: 'wrap',
        paddingTop: 16,
        borderTop: '1px solid #F0F0F0',
    },

    quickFiltersSection: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        flex: 1,
    },

    moreFiltersSection: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
    },

    filterSectionLabel: {
        fontSize: 14,
        fontWeight: 500,
        color: '#595959',
        marginRight: 8,
        whiteSpace: 'nowrap',
    },

    dateRangePicker: {
        '& .ant-picker-input': {
            fontSize: 12,
            fontWeight: 400,
            color: '#000000',
        },
        '& .ant-picker-input input::placeholder': {
            color: '#000000',
        },
        '& .ant-picker-suffix': {
            fontSize: 16,
            color: '#000000',
        },
        '& .ant-picker-separator': {
            color: '#000000',
            fontSize: 12,
            fontWeight: 500,
        },
        '& .ant-picker-active-bar': {
            backgroundColor: '#165ACE',
        },
        borderRadius: '18px !important',
        border: '1px solid #000000 !important',
    },

    dropdownSelect: {
        minWidth: 150,
        '& .ant-select-selector': {
            borderRadius: '18px !important',
            border: '1px solid #000000 !important',
            paddingLeft: '16px !important',
            paddingRight: '12px !important',
        },
        '& .ant-select-selection-item': {
            fontSize: 12,
            fontWeight: 400,
            color: '#000000',
        },
        '& .ant-select-selection-placeholder': {
            fontSize: 12,
            fontWeight: 400,
            color: '#000000',
        },
        '& .ant-select-arrow': {
            fontSize: 12,
            color: '#000000',
        },
        '&:hover .ant-select-selector': {
            borderColor: '#000000 !important',
        },
    },

    inputGroupSelect: {
        width: 200,
        '& .ant-select-selector': {
            borderRadius: '18px 0 0 18px !important',
            border: '1px solid #000000 !important',
            borderRight: 'none !important',
            paddingLeft: '16px !important',
            paddingRight: '12px !important',
        },
        '& .ant-select-selection-item': {
            fontSize: 12,
            fontWeight: 400,
            color: '#000000',
        },
        '& .ant-select-selection-placeholder': {
            fontSize: 12,
            fontWeight: 400,
            color: '#000000',
        },
        '& .ant-select-arrow': {
            fontSize: 12,
            color: '#000000',
        },
    },

    inputGroupInput: {
        flex: 1,
        marginLeft: -1,
        minWidth: 300,
        fontSize: 12,
        fontWeight: 400,
        color: '#000000',
        borderRadius: '0 18px 18px 0 !important',
        border: '1px solid #000000 !important',
        paddingLeft: '16px !important',
        paddingRight: '16px !important',
        '& .ant-input::placeholder': {
            fontSize: 12,
            fontWeight: 400,
            color: '#000000',
        },
    },

    input: {
        flex: 1,
        marginLeft: -1,
        width: 150,
        fontSize: 12,
        fontWeight: 400,
        color: '#000000',
        borderRadius: '18px !important',
        border: '1px solid #000000 !important',
        paddingLeft: '16px !important',
        paddingRight: '16px !important',
    },

    moreFiltersDropdownSelect: {
        minWidth: 150,
        '& .ant-select-selector': {
            borderRadius: '18px !important',
            border: '1px solid #000000 !important',
            paddingLeft: '16px !important',
            paddingRight: '12px !important',
        },
        '& .ant-select-selection-item': {
            fontSize: 12,
            fontWeight: 400,
            color: '#000000',
        },
        '& .ant-select-selection-placeholder': {
            fontSize: 12,
            fontWeight: 400,
        },
        '& .ant-select-arrow': {
            fontSize: 12,
            color: '#000000',
        },
        '&:hover .ant-select-selector': {
            borderColor: '#000000 !important',
        },
    },

    connectedInputGroup: {
        display: 'flex',
        flex: 1,
        minWidth: 300,
    },

    iconButton: {
        width: 36,
        height: 36,
        minWidth: 36,
        padding: 0,
        borderRadius: '18px !important',
        border: '1px solid #000000 !important',
        backgroundColor: '#FFFFFF !important',
        display: 'flex !important',
        alignItems: 'center !important',
        justifyContent: 'center !important',
        cursor: 'pointer',
        transition: 'all 0.3s',
        color: '#000000 !important',
        '& .anticon': {
            fontSize: 16,
            color: '#595959',
        },
    },

    actionButtonsGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginLeft: 'auto',
    },

    resetFilter: {
        color: '#DF1D1D',
        fontSize: 12,
        fontWeight: 600,
        cursor: 'pointer',
        marginLeft: 16,
        fontFamily: 'Open Sans',
    },

    // ========== QUICK FILTER TAGS (needed by FilterBar component) ==========
    filterTagBase: {
        padding: '4px 16px',
        borderRadius: 14,
        fontSize: 13,
        fontWeight: 600,
        lineHeight: '20px',
        cursor: 'pointer',
        transition: 'all 0.3s',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        whiteSpace: 'nowrap',
    },

    filterTagInTransit: {
        backgroundColor: IN_TRANSIT_COLORS.backgroundColor,
        color: IN_TRANSIT_COLORS.textColor,
        '&:hover': {
            backgroundColor: IN_TRANSIT_COLORS.backgroundColor,
        },
    },

    filterTagInTransitActive: {
        backgroundColor: IN_TRANSIT_COLORS.textColor,
        color: IN_TRANSIT_COLORS.backgroundColor,
    },

    filterTagDelivered: {
        backgroundColor: DELIVERED_COLORS.backgroundColor,
        color: DELIVERED_COLORS.textColor,
        '&:hover': {
            backgroundColor: DELIVERED_COLORS.backgroundColor,
        },
    },

    filterTagDeliveredActive: {
        backgroundColor: DELIVERED_COLORS.textColor,
        color: DELIVERED_COLORS.backgroundColor,
    },

    filterTagInProcess: {
        backgroundColor: IN_PROCESS_COLORS.backgroundColor,
        color: IN_PROCESS_COLORS.textColor,
        '&:hover': {
            backgroundColor: IN_PROCESS_COLORS.backgroundColor,
        },
    },

    filterTagInProcessActive: {
        backgroundColor: IN_PROCESS_COLORS.textColor,
        color: IN_PROCESS_COLORS.backgroundColor,
    },

    filterTagCancelled: {
        backgroundColor: CANCELLED_COLORS.backgroundColor,
        color: CANCELLED_COLORS.textColor,
        '&:hover': {
            backgroundColor: CANCELLED_COLORS.backgroundColor,
        },
    },

    filterTagCancelledActive: {
        backgroundColor: CANCELLED_COLORS.textColor,
        color: CANCELLED_COLORS.backgroundColor,
    },

    filterTagAll: {
        backgroundColor: '#F3F4F6',
        color: '#000000',
        '&:hover': {
            backgroundColor: '#F3F4F6',
        },
    },

    // ========== LANES CONTAINER ==========
    lanesContainer: {
        display: 'flex',
        gap: 16,
        flex: 1,
        overflow: 'hidden',
        minHeight: 0,
    },

    // ========== INDIVIDUAL LANE ==========
    lane: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#FFFFFF',
        borderRadius: 12,
        overflow: 'hidden',
        minWidth: 0,
    },

    // ========== LANE HEADERS ==========
    laneHeader: {
        padding: '16px 20px',
        fontSize: 16,
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '2px solid',
        flexShrink: 0,
    },

    laneHeaderInTransit: {
        backgroundColor: IN_TRANSIT_COLORS.backgroundColor,
        color: IN_TRANSIT_COLORS.textColor,
        borderBottomColor: IN_TRANSIT_COLORS.textColor,
    },

    laneHeaderInProcess: {
        backgroundColor: IN_PROCESS_COLORS.backgroundColor,
        color: IN_PROCESS_COLORS.textColor,
        borderBottomColor: IN_PROCESS_COLORS.textColor,
    },

    laneHeaderDelivered: {
        backgroundColor: DELIVERED_COLORS.backgroundColor,
        color: DELIVERED_COLORS.textColor,
        borderBottomColor: DELIVERED_COLORS.textColor,
    },

    laneHeaderCancelled: {
        backgroundColor: CANCELLED_COLORS.backgroundColor,
        color: CANCELLED_COLORS.textColor,
        borderBottomColor: CANCELLED_COLORS.textColor,
    },

    laneHeaderTitle: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
    },

    laneCount: {
        fontSize: 14,
        fontWeight: 500,
        opacity: 0.8,
    },

    // ========== LANE CONTENT ==========
    laneContent: {
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        minHeight: 0,
        backgroundColor: '#F9FAFB',

        // Custom scrollbar
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#F1F1F1',
            borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#C1C1C1',
            borderRadius: '4px',
            '&:hover': {
                background: '#A8A8A8',
            },
        },
    },

    // ========== LANE CARD ==========
    laneCard: {
        flexShrink: 0,
    },

    // ========== CARD STYLES (from grid view for GridView1Card component) ==========
    card: {
        backgroundColor: '#FFFFFF',
        borderRadius: 12,
        border: '1px solid #E8E8E8',
        padding: 24,
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
        transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
        height: '100%',
        cursor: 'pointer',
        '&:hover': {
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
            borderColor: '#D0D0D0',
        },
    },

    cardHeader: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
    },

    avatar: {
        width: 48,
        height: 48,
        minWidth: 48,
        borderRadius: 24,
        backgroundColor: '#D9D9D9',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
    },

    carrierLogoImage: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
    },

    headerContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        flex: 1,
        minWidth: 0,
    },

    shipmentId: {
        fontSize: 18,
        fontWeight: 600,
        lineHeight: '24px',
        color: '#165ACE',
        textDecoration: 'none',
        cursor: 'pointer',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        '&:hover': {
            color: '#40A9FF',
        },
    },

    statusBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 12px',
        borderRadius: 12,
        fontSize: 13,
        fontWeight: 600,
        lineHeight: '20px',
        width: 'fit-content',
        '& .anticon': {
            fontSize: 14,
        },
    },

    statusInProcess: {
        backgroundColor: IN_PROCESS_COLORS.backgroundColor,
        color: IN_PROCESS_COLORS.textColor,
        '& .anticon': {
            color: IN_PROCESS_COLORS.textColor,
        },
    },

    statusCancelled: {
        backgroundColor: CANCELLED_COLORS.backgroundColor,
        color: CANCELLED_COLORS.textColor,
        '& .anticon': {
            color: CANCELLED_COLORS.textColor,
        },
    },

    statusInTransit: {
        backgroundColor: IN_TRANSIT_COLORS.backgroundColor,
        color: IN_TRANSIT_COLORS.textColor,
        '& .anticon': {
            color: IN_TRANSIT_COLORS.textColor,
        },
    },

    statusDelivered: {
        backgroundColor: DELIVERED_COLORS.backgroundColor,
        color: DELIVERED_COLORS.textColor,
        '& .anticon': {
            color: DELIVERED_COLORS.textColor,
        },
    },

    detailsSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
    },

    detailsRow: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: 16,
    },

    detailItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        flex: 1,
        minWidth: 0,
    },

    detailItemRight: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        flex: 1,
        minWidth: 0,
        alignItems: 'flex-end',
    },

    detailLabel: {
        fontSize: 12,
        fontWeight: 400,
        lineHeight: '20px',
        color: '#8C8C8C',
    },

    detailValue: {
        fontSize: 14,
        fontWeight: 600,
        lineHeight: '22px',
        color: '#262626',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },

    detailValueRight: {
        fontSize: 14,
        fontWeight: 600,
        lineHeight: '22px',
        color: '#262626',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        textAlign: 'right',
    },

    emptyValue: {
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '22px',
        color: '#BFBFBF',
    },

    locationSection: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        paddingTop: 4,
    },

    locationItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        flex: 1,
        minWidth: 0,
    },

    locationItemRight: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        flex: 1,
        minWidth: 0,
        alignItems: 'flex-end',
    },

    locationHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        '& .anticon': {
            fontSize: 14,
            color: '#8C8C8C',
        },
    },

    locationText: {
        fontSize: 14,
        fontWeight: 600,
        lineHeight: '22px',
        color: '#262626',
    },

    locationTextRight: {
        fontSize: 14,
        fontWeight: 600,
        lineHeight: '22px',
        color: '#262626',
        textAlign: 'right',
    },

    locationArrow: {
        fontSize: 20,
        color: '#165ACE !important',
        flexShrink: 0,
        marginTop: 18,
    },

    datesSection: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: 16,
        paddingTop: 4,
    },

    // ========== EMPTY LANE STATE ==========
    emptyLane: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        color: '#8C8C8C',
        fontSize: 14,
        fontWeight: 500,
        flex: 1,
    },

    // ========== LOADING STATES ==========
    laneLoader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
    },

    loadMoreContainer: {
        display: 'flex',
        justifyContent: 'center',
        padding: '12px',
        flexShrink: 0,
    },

    // ========== CENTER CONTAINER (for initial loading) ==========
    centerContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'calc(100vh - 300px)',
        backgroundColor: '#F5F5F5',
    },

    emptyStateText: {
        fontSize: 18,
        fontWeight: 500,
        color: '#8C8C8C',
    },

    // ========== RESPONSIVE BEHAVIOR ==========
    '@media (max-width: 1400px)': {
        lanesContainer: {
            gap: 12,
        },
        laneContent: {
            padding: '12px',
            gap: 12,
        },
    },

    '@media (max-width: 1200px)': {
        lanesContainer: {
            flexDirection: 'column',
            overflowY: 'auto',
            overflowX: 'hidden',
        },
        lane: {
            minHeight: '400px',
        },
    },

    '@media (max-width: 768px)': {
        mainDiv: {
            padding: '8px',
        },
        filterBarContainer: {
            padding: '12px 16px',
        },
        topFilterRow: {
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: 8,
        },
        bottomFilterRow: {
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: 12,
        },
        connectedInputGroup: {
            minWidth: 'auto',
            width: '100%',
        },
        actionButtonsGroup: {
            marginLeft: 0,
            justifyContent: 'flex-end',
        },
        laneHeader: {
            padding: '12px 16px',
            fontSize: 14,
        },
        laneContent: {
            padding: '8px',
            gap: 8,
        },
    },
});

export {
    laneView1Styles,
};
